import { useNavigate } from 'react-router-dom';
import appConfig from '../config/appConfig';
import aesEncryptionService from '../services/aesEncryptionService';

export const navigateModule = async (
  module: string,
  websiteid: string,
  websiteUrl: string,
  navigate: ReturnType<typeof useNavigate>
) => {
  const UserDetails = sessionStorage.getItem("UserDetails");
  if (!UserDetails) {
    console.warn("No UserDetails found in sessionStorage.");
    return;
  }

  if (!websiteUrl) {
    navigate("/inprogress", {
      state: { module }   // 👈 pass module name
    });
    console.error(module, "module has no URL:", websiteUrl);
    return;
  }

  // If URL is InProgress
  if (websiteUrl === "https://erp.psgtech.ac.in/inprogress") {
    navigate("/inprogress", {
      state: { module }   // pass module name
    });
    return;
  }


  try {
    // Create a form
   // Check if URL is ASP.NET page
    const isAspx = websiteUrl.toLowerCase().endsWith(".aspx");

    if (isAspx) {
      // ✅ POST ONLY for ASP.NET pages
      const form = document.createElement("form");
      form.method = "POST";
      form.action = websiteUrl;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "data";
      input.value = UserDetails; // encrypted data
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

    } else {
      // ✅ React / SPA navigation
      sessionStorage.setItem("UserDetails", UserDetails);
      window.location.href = websiteUrl;
    }
  } catch (error) {
    console.error("Error navigating via POST:", error);
  }
};
